import axios from 'axios'

export const searchCep = async (zipcode: string) => {
  const formatedZipcode = zipcode.replace('-', '')
  const { data } = await axios.get(`https://viacep.com.br/ws/${formatedZipcode}/json/`)

  return { data }
}
